<div class="flex-row align-center-center">
    <mat-icon class="mrs-2" [ngClass]="leftIconClass" *ngIf="leftIcon">
        {{ leftIcon }}
    </mat-icon>
    <mat-icon class="mrs-2" style="min-height: 20px;" [ngClass]="leftIconClass" *ngIf="leftIconSvg"
        [svgIcon]="leftIconSvg">
    </mat-icon>
    <mat-form-field class="full-width" [formGroup]="form"
        [appearance]="inputBgColor ? 'fill' : 'outline'"
        [ngStyle]="inputBgColor ? {
            '--mdc-filled-text-field-container-color': inputBgColor,
            '--mdc-filled-text-field-active-indicator-color': 'transparent',
            '--mdc-filled-text-field-focus-active-indicator-color': 'transparent',
            '--mdc-filled-text-field-disabled-active-indicator-color': 'transparent'
          } : null">
        <mat-label *ngIf="this.label">
            <mat-icon *ngIf="this.icon">{{ icon }}</mat-icon>
            {{ label }}
        </mat-label>
        <mat-hint>{{ this.hint }}</mat-hint>
        <input matInput [formControlName]="name" id="{{ name }}" name="{{ name }}" type="text"
            placeholder="{{ placeholder }}" [readonly]="readonly" (keyup.enter)="this.enter.emit()"
            (change)="this.changes.emit()" [attr.disabled]="disabled ? '' : null"
            [attr.inputmode]="numericOnly ? 'numeric' : null" (input)="onInput($event)" (click)="selectAll()" />
        <button tabIndex="-1" [disabled]="!this.form.get(this.name)?.value || this.form.get(this.name)?.disabled"
            type="button" mat-button *ngIf="this.clearable" matSuffix mat-icon-button [attr.aria-label]="'shared.text-input.clear' | exp:'':'Limpiar'"
            (click)="this.form.get(this.name)?.reset()">
            <mat-icon>close</mat-icon>
        </button>
        <!-- @if (this.form.get(this.name)?.errors && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched)) {
            <mat-error> {{ getError() }} </mat-error>
        } -->
        @if (maxLength) {
            <mat-hint align="end">{{ form.get(name)?.value?.length || 0 }}/{{ maxLength }}</mat-hint>
        }
        <mat-error *ngIf="hasError('pattern')">
            {{ 'shared.text-input.solo-se-permiten-numeros' | exp:'':'Solo se permiten números' }}
        </mat-error>
        <mat-error *ngIf="hasError('required')">
            {{ !!this.getError() ? this.getError() : ('shared.text-input.este-campo-es-obligatorio' | exp:'':'Este campo es obligatorio') }}
        </mat-error>
        <mat-error *ngIf="hasError('maxlength')">
            {{ 'shared.text-input.se-excedio-el-numero-maximo-de-caracteres' | exp:'':'Se excedió el número máximo de caracteres' }}
        </mat-error>
        <mat-error *ngIf="hasError('number')">
            {{ 'shared.text-input.solo-puede-ingresar-numeros' | exp:'':'Solo puede ingresar números' }}
        </mat-error>
    </mat-form-field>
</div>
